import React, { Component } from 'react';
import { MsalContext } from "@azure/msal-react";
import Dropdown from "react-bootstrap/Dropdown";
import Dashboard from "../../../Dashboard";

import { loginRequest } from "../../../../../authConfig";
import { callMsGraph } from "../../../../../graph";

import fetchAPI from "../../../../../components/utils/fetchAPI";

import runtimeEnv from '@mars/heroku-js-runtime-env';

//Styless
import './SingleSingOn.scss';

const env = runtimeEnv();

export default class SingleSingOn extends Component {

  static contextType = MsalContext;

  state = {
    userName: "",
    switchSelectNDashboard: true,
    appName: "Honey Load",
    selectedCountry: "",
    selectedCountryCode: "",
    selectedCountryPrev: "",
    selectedCountryCodePrev: "",
    availableCountries: [],
    selectedProduct: " - ",
    tabView: null,
    // usersAccess: {
    //   name1: "mario.rosas-ext@ab-inbev.com",
    // },

  };

  componentDidMount() {
    this.fetchCountries();
    this.requestProfileData();
  }

  requestProfileData() {
    // Silently acquires an access token which is then attached to a request for MS Graph data
    this.context.instance.acquireTokenSilent({
      ...loginRequest,
      account: this.context.accounts[0]
    }).then((response) => {

      callMsGraph(response.accessToken).then(response => {
        this.setGraphData(response);
        this.setState({
          userName: response.displayName.toUpperCase(),
          userPrincipalName: response.userPrincipalName
        })
      });

    }).catch((e) => {
      console.log(e);
    });
  }

  handleDropdown = (selectedValue, evt) => {
    this.setState({
      selectedCountryPrev: evt.target.outerText,
      selectedCountryCodePrev: selectedValue,
    });

    if (this.state.selectedProduct === " - ") {
      this.setState({
        selectedCountry: evt.target.outerText,
        selectedCountryCode: selectedValue,
      });
    }
  };

  handleCountryUpdate = (countryName, countryCode) => {
    this.setState({
      selectedCountryPrev: countryName,
      selectedCountryCodePrev: countryCode,
    });

    if (this.state.selectedProduct === " - ") {
      this.setState({
        selectedCountry: countryName,
        selectedCountryCode: countryCode,
      });
    }
  };

  fetchNewUser = async () => {

    let mdCountry;
    let countryName;
    switch (this.context.accounts[0].idTokenClaims.ctry) {
      case "MX":
        mdCountry = 'mdmexico'
        countryName = 'Mexico'
        break;
      case "CO":
        mdCountry = 'mdcolombia'
        countryName = 'Colombia'
        break;
      case "EC":
        mdCountry = 'mdecuador'
        countryName = 'Ecuador'
        break;
      case "PE":
        mdCountry = 'mdperu'
        countryName = 'Peru'
        break;
    
      default:
        mdCountry = 'mdcolombia'
        countryName = 'Colombia'
        break;
    }

    const params = {
      clientId: this.context.accounts[0].idTokenClaims.oid,
      clientName: this.context.accounts[0].idTokenClaims.name,
      clientEmail: this.context.accounts[0].idTokenClaims.preferred_username,
      country: countryName,
    }
    fetchAPI({
      service: env.REACT_APP_SERVICES_GET_ALL_USERS + '/' + mdCountry,
      protocol: "POST",
      params: params,
      verifyAuth: false,
      callbackThen: (response) => {
        console.log(response)
        try {
          this.setState({
            userData: response,
          })
        } catch (error) {
          console.log(error)
        }
      }
    })
  }

  fetchCountries = async () => {
    fetchAPI({
      service: env.REACT_APP_SERVICES_GET_COUNTRIES,
      protocol: "GET",
      callbackThen: (response) => {
        // console.log({'responses': response,})
        try {
          const firstOption = [{ name: "Selecciona un país", code: "0" }];
          const options = firstOption.concat(response);
          for (var option in options) {
            if (options[option].name === "México") {
              this.setState({
                availableCountries: options,
                selectedCountry: options[option].name,
                selectedCountryCode: options[option].code,
              });
              this.handleCountryUpdate(
                options[option].name,
                options[option].code
              );
            }
          }
        } catch (e) {
          this.setState({
            availableCountries: [],
            selectedCountry: "No existen países",
          });
        }
      },
    });
  };

  setSelectedCountry = (country) => {
    this.setState({
      selectedCountry: country,
    });
  };

  onClickPrueba = (ev) => {
    this.setState({
      switchSelectNDashboard: false
    })
  }

  render() {

    return(
      this.state.switchSelectNDashboard  ?  
        <div className="login">
          <div className="login_container">
            <div className="login_logo-bees"></div>
            <div className="login_label-name">
              {this.state.appName}
            </div>
            <div className="login_user-name">
              {`Hola ${this.context.accounts[0].name}, bienvenido!`}
            </div>
            <div className="login_label-name">
              <Dropdown
                onSelect={this.handleDropdown}
                // disabled={true}
                className="login__dropdown"
              >
                <Dropdown.Toggle id="dropdown-basic">
                <img 
                  style={{marginRight: '9rem'}} 
                  width="30" 
                  heigth="30" 
                  src={this.state.selectedCountry === "Colombia" 
                    ? "/assets/banderas/colombia.svg" 
                    : this.state.selectedCountry === "México"
                    ? "/assets/banderas/mexico.svg"
                    : this.state.selectedCountry === "Perú"
                    ? "/assets/banderas/PeruSinFondo.png"
                    : this.state.selectedCountry === "Ecuador"
                    ? "/assets/banderas/ecuador.svg"
                    : this.state.selectedCountry === "Panama"
                    ? "/assets/banderas/panama.svg"
                    : null
                  } 
                  alt="Country Selected"
                />
                  {this.state.selectedCountry}
                </Dropdown.Toggle>

                <Dropdown.Menu className="login__dropdown-menu">
                  {/* {console.log(this.state.availableCountries)} */}
                  {this.state.availableCountries.map((element) => (
                    element.name !== 'Colombia' && element.name !== "México"
                    ? null
                    :<Dropdown.Item eventKey={element.code}
                      style={{display:"flex"}}
                    >
                      <img 
                        style={{marginRight: '1rem'}} 
                        width="30" 
                        heigth="30" 
                        src={element.name === "Colombia" 
                          ? "/assets/banderas/colombia.svg" 
                          : element.name === "México"
                          ? "/assets/banderas/mexico.svg"
                          : element.name === "Perú"
                          ? "/assets/banderas/PeruSinFondo.png"
                          : element.name === "Ecuador"
                          ? "/assets/banderas/ecuador.svg"
                          : element.name === "Panama"
                          ? "/assets/banderas/panama.svg"
                          : null
                        } 
                        alt="Country Select"
                      />
                      {element.name}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div className="login_button-container">
              <button 
                className="login_button" 
                type="button"
                onClick={this.onClickPrueba}
                >Aceptar
              </button>
            </div>
          </div>
        </div>
        /* TODO */
      : <Dashboard 
          userData={this.state.userData}
          country={ this.state.selectedCountry}
          countriesCode={this.state.selectedCountryCode}
        />
    )
  }

}